import React from 'react';
import { Link } from 'gatsby';
import { edgeTest, decodeEntities } from '../../utils/helpers'

export default class GatsbyLink extends React.Component {

  scrollIntoView = (event, containerId) => {
    if (typeof window !== 'undefined') {
      event.preventDefault();
      containerId = containerId.replace('#','')
      const results = document.getElementById(containerId) ? document.getElementById(containerId) : null;
      results && results.scrollIntoView({ block: 'start',  behavior: 'smooth' });
    }
  }

  render() {
    const {to, activeClassName = "active", children, data, decode = false,  target = null, ...other } = this.props
   
    const targetPars = to?.includes('.pdf') ? '_blank' : target

    if ( to && to.includes('#') ) {
      return <span onClick={event => this.scrollIntoView(event, to)} {...other}>{decode ? decodeEntities(children) : children}</span>
    }

    if (to && to.startsWith('/') && edgeTest() && !to.includes('.')) {
      return <Link activeClassName={activeClassName} {...other} to={to}>{decode ? decodeEntities(children) : children}</Link>
    }

    return (
      <a href={to} target={targetPars} {...other} >{decode ? decodeEntities(children) : children}</a>
    )
  }
}
